import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import hexagon from "./hexagon.svg";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  tagline,
  title,
  title_hexagon = false,
  description,
  buttons,
  buttonsClassName = "mt-5",
  EditableText,
  EditableHtml,
  md = 12,
  bg = bg_1,
  bgStyle = {
    top: 0,
    right: 0,
  },
  theme = "light",
}) {
  return (
    (description || title) && (
      <div className={cn(className, classes.Content)} data-bs-theme={theme}>
        {bg && <ParallaxBackground anim="y2n:x0:z0" image={bg} floating={false} style={bgStyle} />}
        <Container fluid="md">
          <Row>
            <Col xs={12} md={md}>
              <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                <span dangerouslySetInnerHTML={{ __html: tagline }} />
              </Tagline>
              <div className="d-flex gap-3 align-items-center mb-4">
                {title_hexagon && <img src={hexagon} alt="" />}
                <EditableText path="title" tag="h2" className="mb-0">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </EditableText>
              </div>
              <EditableHtml path="description" className="description">
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </EditableHtml>
              <Buttons buttons={buttons} className={buttonsClassName} />
            </Col>
          </Row>
        </Container>
      </div>
    )
  );
}
